export type RestrictedErrorType =
  | 'restricted_location'
  | 'plant_disabled'
  | 'no_internet'
  | 'server_error'
  | 'maintenance'
  | 'gps_off'
  | 'config_missing';

export interface RestrictedAreaError {
  type: RestrictedErrorType;
  message: string;
  subMessage?: string | undefined;
}

export function resolveRestrictedError(errorMessage: string): RestrictedAreaError {
  const lower = errorMessage.toLowerCase();

  if (lower.includes('restricted') || lower.includes('geofence') || lower.includes('boundary')) {
    return {
      type: 'restricted_location',
      message: 'Restricted Area',
      subMessage: errorMessage,
    };
  }

  if (lower.includes('plant') && lower.includes('disabled')) {
    return {
      type: 'plant_disabled',
      message: 'Plant Unavailable',
      subMessage: errorMessage,
    };
  }

  if (lower.includes('internet') || lower.includes('network') || lower.includes('offline')) {
    return {
      type: 'no_internet',
      message: 'No Internet Connection',
      subMessage: errorMessage,
    };
  }

  if (lower.includes('maintenance')) {
    return {
      type: 'maintenance',
      message: 'Under Maintenance',
      subMessage: 'We apologize for the inconvenience. The system is currently under maintenance.',
    };
  }

  if (lower.includes('server') || lower.includes('unavailable') || lower.includes('503')) {
    return {
      type: 'server_error',
      message: 'Server Unavailable',
      subMessage: 'We apologize for the inconvenience. Our servers are temporarily unavailable.',
    };
  }

  if (lower.includes('gps') || lower.includes('location') || lower.includes('permission')) {
    return {
      type: 'gps_off',
      message: 'Location service is disabled. Please enable location in the device.',
    };
  }

  if (lower.includes('config') || lower.includes('configuration')) {
    return {
      type: 'config_missing',
      message: 'Configuration Missing',
      subMessage: errorMessage,
    };
  }
  return {
    type: 'gps_off',
    message: 'Access Restricted',
    subMessage: errorMessage,
  };
}
